export default "__VITE_ASSET__BLglhcf9__"